import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card, CardBody, Container, Row } from 'reactstrap';

import Loader from 'components/Loader';
import SimpleHeader from 'components/Headers/SimpleHeader';
import { useRecordTypesByUser } from 'views/RecordType/hooks/useRecordTypesByUser';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import ContactList from './components/ContactList';
import ListContactsHeader from './components/ListContactsHeader';
import ImportContactsModal from './components/ImportContactsModal';
import {
  POSSIBLE_FILTERS_ENTITIES,
  useMemorizeFilters
} from '../../../../hooks/useMemorizeInputsFilters';

function ContactListIndex() {
  const [selectedRecordType, setSelectedRecordType] = useState(null);
  const { recordTypes, isLoadingRecordTypes, getRecordTypesByUser } =
    useRecordTypesByUser(entitiesName.CONTACT);
  const { getMemorizedFilters } = useMemorizeFilters(
    POSSIBLE_FILTERS_ENTITIES.CRM_CONTACT
  );

  useEffect(() => {
    getRecordTypesByUser();
  }, [getRecordTypesByUser]);

  useEffect(() => {
    if (recordTypes && recordTypes.length) {
      const merorizedRecordType = getMemorizedFilters();
      if (!merorizedRecordType?.recordTypeId) {
        setSelectedRecordType(recordTypes[0]);
        return;
      }
      const recordType = recordTypes.find(
        (rt) => rt.id === merorizedRecordType.recordTypeId
      );
      if (!recordType) {
        setSelectedRecordType(recordTypes[0]);
        return;
      }

      setSelectedRecordType(recordType);
    }
  }, [getMemorizedFilters, recordTypes]);

  const handleSelectRecordType = useCallback(
    (recordTypeId) => {
      setSelectedRecordType(recordTypes.find((rt) => rt.id === recordTypeId));
    },
    [recordTypes]
  );

  const getChildToRender = () => {
    if (isLoadingRecordTypes) {
      return (
        <div className="col-12">
          <Row className="justify-content-md-center">
            <Loader />
          </Row>
        </div>
      );
    }

    if (!recordTypes && !isLoadingRecordTypes) {
      return (
        <div>
          <span className="small">
            Você não tem acesso a nenhum tipo de contato.
          </span>
        </div>
      );
    }

    return (
      <ContactList
        selectedRecordTypeId={selectedRecordType?.id}
        setSelectedRecordType={setSelectedRecordType}
        recordTypes={recordTypes}
      />
    );
  };

  return (
    <>
      <SimpleHeader
        setCreate={`/admin/crm/contactForm/${selectedRecordType?.id}`}
        name="Form validation"
        parentName="Forms"
        returnPath="/admin"
        showBackArrow="not"
      >
        <ImportContactsModal
          buttonOpenModal={({ onClick }) => (
            <Button onClick={onClick}>Importar</Button>
          )}
        />
      </SimpleHeader>
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <ListContactsHeader
                  title="Contatos"
                  recordTypes={recordTypes}
                  selectedRecordType={selectedRecordType}
                  handleSelectRecordType={handleSelectRecordType}
                />
                <CardBody className="pt-2">{getChildToRender()}</CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}

export default ContactListIndex;
